/**
 * J-CAT Wabunka サポート用メールアドレス
 */

// 体験詳細ページからの予約時の問い合わせ先メールアドレス
export const EMAIL_WABUNKA_SUPPORT = 'global-support@wabunka-media.jp';

// Contact us、Partner with usの問い合わせ先メールアドレス
export const EMAIL_WABUNKA_GPD = 'wabunka-gpd@j-cat.co.jp';

// Contact usのお問い合わせ先メールアドレス
export const EMAIL_WABUNKA_GCS = 'global-support@wabunka-media.jp';
